// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2EJ6q","header":"ReportDetails_header__3gZMO","title":"ReportDetails_title__34z4i","left":"ReportDetails_left__2AuiY"};